/**
`com-calendar-drawer`
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-calendar-drawer-style.js';

import '@polymer/polymer/lib/elements/dom-if.js';

class COMCalendarDrawer extends PolymerElement {
  static get template() {
    return html`
    <style include="com-theme"></style>
    <style include="com-calendar-drawer-style"></style>

    <div id="drawerContent"><slot name="drawerContent"></slot></div>
`;
  }

  static get is() { return 'com-calendar-drawer'; }
  static get properties() {
    return {

      /**
       * @desc activate animation
       * @type Boolean
       */
      animate: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      /**
       * @desc show drawer
       * @type Boolean
       */
      open: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      /**
       * @desc drawer enable state
       * @type {Boolean}
       */
      enable: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      /**
       * @desc allow fade in animation when first showing drawer
       * @type Boolean
       */
      fadeIn: {
        type: Boolean,
        value: true,
        reflectToAttribute: true
      }
    };
  }

  static get observers() {
    return [
      '_checkOpen(animate)',
      '_checkFadeIn(open)'
    ];
  }

  ready() {
    super.ready();
    this.addEventListener('animationend', (event) => {
      this.animate = false;
      this.fadeIn = false;
    });
  }

  /**
   * @desc automatically open drawer when triggering animation
   * @param {Boolean} animate
   */
  _checkOpen(animate) {
    if (animate) {
      this.open = true;
    }
  }

  /**
   * @desc allow fade in animation when drawer shows again
   * @param {Boolean} open
   */
  _checkFadeIn(open) {
    if (!open) {
      this.fadeIn = true;
    }
  }
}
window.customElements.define(COMCalendarDrawer.is,COMCalendarDrawer);
